//@flow
import {makeStyles, Typography} from '@material-ui/core';
import React from 'react';

import CustomModal from '../../../../../../elements/CustomModal/CustomModal';
import {useBannerOpened, useBannerActions} from '../../../../utils';
import DesktopPreview from './DesktopPreview';
import MobilePreview from './MobilePreview';

const useStyles = makeStyles(theme => ({
  root: {
    height: '90vh',
    marginBottom: '2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    maxWidth: '900px',
  },
  title: {
    fontSize: '1rem',
    fontWeight: '600',
  },
  content: {
    height: '90%',
    background: '#F2F2F2',
    borderRadius: '.75rem',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '1.5rem',
    overflow: 'auto',
  },
  preview: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    minWidth: '600px',
  },
}));

export default function BannerPreview() {
  const classes = useStyles();

  const banner = useBannerOpened();
  const {closeBanner} = useBannerActions();

  return (
    <CustomModal
      open={!!banner}
      handleCloseModal={() => {
        closeBanner();
      }}
    >
      <div className={classes.root}>
        <header>
          <Typography className={classes.title}>
            Previsualización de Banner
          </Typography>
        </header>

        <aside className={classes.content}>
          <div className={classes.preview}>
            <DesktopPreview />
            <MobilePreview />
          </div>
        </aside>

        {/* <footer className={classes.footer}></footer> */}
      </div>
    </CustomModal>
  );
}
